import { Injectable, Injector } from '@angular/core';
import { FiBackendService } from '@fi-shared/fi-backend/fi-backend.service';
import { AreaModel, IAreaModel, LightWeightAreaModel } from './area.model';
import { CoreParameterModel, ILightWeightArea, ILightWeightObjectCollection } from '@fi-shared/models';
import { AreaDeleteModel } from './area-delete/area-delete.model';
import { IItemsListDataFetchResult, IItemsListParameterBase } from '@fi-shared/fi-items-list/fi-items-list';
import { fiItemsFlatten } from '@fi-shared/utils/fi-items-flatten';
import { LoadingService } from '@fi-shared/fi-loading/loading.service';

@Injectable()
export class AreaService {
    constructor(
        private fiBackend: FiBackendService,
        private fiLoading: LoadingService,
        private injector: Injector,
    ) {}

    GetArea(id) {
        return new Promise<AreaModel>((resolve, reject) => {
            if (id > 0) {
                this.fiBackend.fetchData<IAreaModel>(`Core/Area/GetArea/${id}`).then((response) => {
                    resolve(new AreaModel(response, this.injector));
                }, reject);
            } else {
                resolve(new AreaModel(undefined, this.injector));
            }
        });
    }

    // note: not used
    GetLightWeightParentAreas() {
        return this.fiBackend.fetchData('Core/Area/GetLightWeightParentAreas');
    }

    //Will be used in accessrights
    GetLightWeightHieracialAreas() {
        const promise = new Promise<AreaModel[]>((resolve, reject) => {
            const areas = [];

            this.fiBackend.fetchData<any[]>('Core/Area/GetLightWeightHieracialAreas').then(
                (response) => {
                    response.forEach((item) => {
                        const area = new AreaModel(item, this.injector);
                        areas.push(area);
                    });
                    resolve(areas);
                },
                () => {
                    reject();
                },
            );
        });

        return promise;
    }

    getLightWeightHieracialAreasPlain() {
        // todo use getLightWeightFlattenAreas ?
        return this.fiBackend.fetchData<ILightWeightArea[]>('Core/Area/GetLightWeightHieracialAreas');
    }

    getLightWeightFlattenAreas() {
        return new Promise<ILightWeightArea[]>((resolve, reject) => {
            this.fiBackend.fetchData<ILightWeightArea[]>('Core/Area/GetLightWeightHieracialAreas').then((areas) => {
                resolve(fiItemsFlatten(areas));
            }, reject);
        });
    }

    GetLightWeightAreas() {
        return this.fiBackend.fetchData<Array<LightWeightAreaModel>>('Core/Area/GetLightWeightAreas');
    }

    SaveArea(area: AreaModel) {
        //Creating a new object because it looks bad in the GUI otherwise.
        const areaApiModel = JSON.parse(JSON.stringify(area));

        const promise = new Promise<number>((resolve, reject) => {
            this.fiBackend.fetchDataPost<number>('Core/Area/SaveArea', areaApiModel).then(
                (response) => {
                    resolve(response);
                },
                () => reject(),
            );
        });

        return promise;
    }

    getAreasListData(parameter: IItemsListParameterBase) {
        return this.fiBackend.fetchDataPost<IItemsListDataFetchResult<IAreaModel>>(
            'Core/Area/GetAreasListData',
            parameter,
        );
    }

    GetAreas(areaParameterApiModel: CoreParameterModel) {
        return this.fiBackend.fetchDataPost<any[]>('Core/Area/GetAreas', areaParameterApiModel);
    }

    GetAreasCount(areaParameterApiModel: CoreParameterModel) {
        return this.fiBackend.fetchDataPost<number>('Core/Area/GetAreasCount', areaParameterApiModel);
    }

    GetLightWeightObjectsForLocalSearch(areaParameterApiModel: CoreParameterModel) {
        return this.fiBackend.fetchDataPost<ILightWeightObjectCollection>(
            'Core/Area/GetLightWeightObjectsForLocalSearch',
            areaParameterApiModel,
        );
    }

    UpdateAreaAccessRights(areaRightUpdate) {
        return this.fiBackend.fetchDataPost('Core/Area/UpdateAreaAccessRights', areaRightUpdate);
    }

    DeleteArea(data: AreaDeleteModel) {
        return this.fiLoading.trackPromise(this.fiBackend.fetchDataPost<void>('Core/Area/DeleteArea', data));
    }
}
